<template>
  <div>
    <Contact ref="Contact"></Contact>

    <el-divider content-position="left">我的产品({{myProducts.length}})</el-divider>
    <div class="product-el-body" v-loading="loading" :style="'width:'+myProductDivWidth+'px;'">
      <div class="prolist-ul">
        <div class="prolist-div" v-for="(p,i) in myProducts" :key="i"  :class="{active : product==p}" >
          <div class="product-info">
            <span>{{p.type}}</span>
          </div>
          <img :src="getImgUrl('propic/'+p.model+'.png')" alt="" class="product-img" @click="chooseMyProduct(p)">
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-div" style="margin-top: 50px;font-size: 14px;color: #909399">正在查询我的产品..</div>
    <div v-if="noExistAssets" class="noAssets-div" style="margin-top: 50px;font-size: 14px;color: #909399">暂无已有产品</div>
    <Product ref="Product" @notMyProduct="notMyProduct"></Product>
  </div>

</template>

<script>
    import Contact from "../../components/Contact"
    import Product from "../../components/Product"

    export default {
        name: "ContactAndProduct",
        components:{
            Contact,
            Product
        },
        data() {
            return {
                contact: {},
                product: {},

                loading: true,
                noExistAssets: false,

                myProducts: [],

                existAssetsId: 0,
                existProductId: 0,
                snCode: '',

                myProductDivWidth: document.documentElement.clientWidth - 68,

                // 显示的产品型号
                productNameArr: [
                    'X1','X3'
                    // ,
                    // 'G27',
                    // 'MX-B048047A-BS','MX-B048045C-BS','MX-B048046C-BD','MX-C048A-BS','MX-B048045A-BS',
                    // 'MX-B055046A-BS','MX-B048045B-BS','MX-B055046B-BS','MX-B048046B-BD','MX-C050055A-BE',
                    // 'MX-C130092A-BS','MX-C150093A-BS','MX-C150093A-BD','MX-C130086A-BS','MX-C130095B-BE',
                    // 'MX-C150A-BS','MX-D082065A-BS','MX-D128110A-BS','MX-A012023A-AS','MX-A018030A-AS',
                    // 'MX-A024035D-BS24W','MX-A024A-AS','MX-A024C-AS','MX-A024D-AS','MX-A018030B-AS',
                    // 'MX-A024035B-AS','MX-A018030C-AS','MX-B024035B-AS','MX-B024035A-AS','MX-B12440-A',
                    // 'MX-B12440-B','MF-A136A-BS','MF-B069A-BS',

                    // ,'MY-B2K4060C-AD','MY-A2K4060A-AD','MY-B2K4060D-BD','MY-A2K4060B-BD'
                ],
                // 智能锁系列包含的产品型号
                Series1: [
                    'X1','X3'
                ],
                // 智能开关系列包含的产品型号
                Series2: [
                    'G27'
                ],
                // 卧室灯系列包含的产品型号
                Series3: [
                    'MX-B048047A-BS','MX-B048045C-BS','MX-B048046C-BD','MX-C048A-BS','MX-B048045A-BS',
                    'MX-B055046A-BS','MX-B048045B-BS','MX-B055046B-BS','MX-B048046B-BD','MX-C050055A-BE'
                ],
                // 客厅灯系列包含的产品型号
                Series4: [
                    'MX-C130092A-BS','MX-C150093A-BS','MX-C150093A-BD','MX-C130086A-BS','MX-C130095B-BE',
                    'MX-C150A-BS','MX-D082065A-BS'
                ],
                // 吸顶灯系列包含的产品型号
                Series5: [
                    'MX-D128110A-BS','MX-A012023A-AS','MX-A018030A-AS','MX-A024035D-BS24W','MX-A024A-AS',
                    'MX-A024C-AS','MX-A024D-AS','MX-A018030B-AS','MX-A024035B-AS','MX-A018030C-AS',
                    'MX-B024035B-AS','MX-B024035A-AS','MX-B12440-A','MX-B12440-B'
                ],
                // 吊灯系列包含的产品型号
                Series6: [
                    'MF-A136A-BS','MF-B069A-BS'
                ],
                // 浴霸系列包含的产品型号
                Series7: [
                    'MY-B2K4060C-AD','MY-A2K4060A-AD','MY-B2K4060D-BD','MY-A2K4060B-BD'
                ],
            }
        },

        // activated() {
        //     // 在选择产品/联系地址后，返回页面时触发
        //     this.product = this.$refs.Product.s_product;
        //     this.contact = this.$refs.Contact.contact;
        //
        //     // 若根据unionid查询无联系人资产，则根据所选联系人的电话号码查询
        //     if(this.existAssetsId==0 && this.$route.params.contact){
        //         this.loading = true;
        //         this.noExistAssets = false;
        //         console.log("查询此号码下产品:",this.contact.phone);
        //         this.$axios.get(this.$baseURL + `/rnow/phoneassets/` + this.contact.phone)
        //             .then(data=> {
        //                 if(data.data==null || data.data=="" || data.data=='undefined'){
        //                     // 该phone下无联系人资产
        //                     this.existAssetsId = 0 ;
        //                     this.noExistAssets = true ;
        //                     this.myProducts.length = 0;
        //                     console.log("phone下无资产")
        //                 }else {
        //                     this.myProducts.length = 0;
        //                     for(let j = 0,len=data.data.length; j < len; j++) {
        //                         if(this.productNameArr.indexOf(data.data[j][3])<0){
        //                             continue;
        //                         }
        //                         let p = {assetsId:data.data[j][0], productId:data.data[j][1], type:data.data[j][2],model:data.data[j][3],snCode:data.data[j][4]};
        //                         this.myProducts.push(p);
        //                     }
        //                     if(this.myProducts.length == 0){
        //                         this.noExistAssets = true ;
        //                     }
        //                 }
        //                 this.loading = false;
        //             })
        //             .catch(error=> {
        //                 console.log(error);
        //                 this.loading = false;
        //             });
        //
        //     }
        // },
        methods: {
            setMyProducts(myProducts){
                this.loading = false;
                if(myProducts.length == 0) {
                    this.noExistAssets = true;
                    if(!(JSON.stringify(this.$refs.Contact.contact)=='{}')){
                        // 若unionid下无资产，根据contact的联系电话查找资产
                        this.searchMyProductByPhone(this.$refs.Contact.contact.phone);
                    }
                }else {
                    this.myProducts = myProducts;
                }
            },
            getImgUrl(icon){
                return require("@/assets/"+icon);
            },
            // 选择我的产品，同时产品子组件中取消选择
            chooseMyProduct(p){
                this.product = p;
                this.$refs.Product.quiet();
                this.existAssetsId = p.assetsId;
                this.existProductId = p.productId;
                this.snCode = p.snCode;
                this.product.img = this.getImgUrl('propic/'+this.product.model+'.png');
                this.$refs.Product.s_product = this.product;
                this.$refs.Product.hasProduct = true;
                console.log("123:",this.$refs.Product.s_product)
            },
            // 产品子组件中选择，调用该方法
            notMyProduct(){
                this.product = this.$refs.Product.s_product;
                this.existAssetsId = 0;
                this.existProductId = 0;
                console.log("产品子组件:",this.product)
            },
            searchMyProductByPhone(phone){
                console.log("根据手机号 " + phone + " 查找资产");
                this.loading = true;
                this.noExistAssets = false;
                this.$axios.get(this.$baseURL + `/rnow/phoneassets/` + phone)
                    .then(data=> {
                        if(data.data==null || data.data=="" || data.data=='undefined'){
                            // 无联系人资产
                            this.noExistAssets = true;
                            console.log("ContactAndProduct myProducts: 该phone下无资产");
                        }else {
                            console.log(data.data);
                            for(let j = 0,len=data.data.length; j < len; j++) {
                                if(this.productNameArr.indexOf(data.data[j][3])<0){
                                    continue;
                                }
                                let p = {
                                    assetsId:data.data[j][0],
                                    productId:data.data[j][1],
                                    type:data.data[j][2],
                                    series:this.confirmProductSeriesByModel(data.data[j][3]),
                                    model:data.data[j][3],
                                    snCode:data.data[j][4]};
                                this.myProducts.push(p);
                            }
                            console.log("ContactAndProduct myProducts: ",this.myProducts);
                            if(this.myProducts == undefined || this.myProducts.length <= 0){
                                this.noExistAssets = true;
                            }
                        }
                        this.loading = false;
                    })
                    .catch(error=> {
                        console.log(error);
                    });
            },
            confirmProductSeriesByModel(model){
                if(this.Series1.indexOf(model)>=0){
                    return "智能锁"
                }else if(this.Series2.indexOf(model)>=0){
                    return "智能开关"
                }else if(this.Series3.indexOf(model)>=0){
                    return "卧室灯"
                }else if(this.Series4.indexOf(model)>=0){
                    return "客厅灯"
                }else if(this.Series5.indexOf(model)>=0){
                    return "吸顶灯"
                }else if(this.Series6.indexOf(model)>=0){
                    return "吊灯"
                }else if(this.Series7.indexOf(model)>=0){
                    return "浴霸"
                }
            }
        },
        activated() {
            // 在选择产品/联系地址后，返回页面时触发
            // this.product = this.$refs.Product.s_product;
            this.contact = this.$refs.Contact.contact;
            // console.log("ContactAndProduct activated");
            // console.log(this.product)
        },
        watch: {
            // 监听product：当product改变且不为空时，改变父页面的product
            product: {
                handler(){
                    if(!(JSON.stringify(this.product)=='{}')){
                        this.$emit('chooseProductChanged');
                        console.log(this.product);
                        console.log("changed")
                    }
                },
                deep: true
            },
            contact: {
                handler(){
                    if(this.noExistAssets && !(JSON.stringify(this.contact)=='{}')){
                        // 若unionid下无资产，根据contact的联系电话查找资产
                        this.searchMyProductByPhone(this.contact.phone);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
  .product-el-body {
    /*width: 500px;*/
    font-size: 14px;
    color: #999;
    align-items: center;
    justify-content: center;
    padding: 0px 10px;
  }
  .prolist-ul {
    margin-top: 0px;
    width: 100%;
    padding: 0px;
    overflow-x: auto;
    display: flex;
  }
  .active {
    box-shadow: 0 0 4px 2px #ddd;
    border: 1px solid #2283E2;
    border-radius: 8px;
  }
  .noAssets-div {
    margin-top: 0px!important;
  }
</style>
